import React from 'react';

import { Size } from '../../../core/enums/Size';
import { Color } from '../../../core/enums/Color';
import Tooltip from '../../../components/tooltip/Tooltip';

import './Badge.scss';

export type BadgeSize = Size.Small | Size.Medium | Size.Large | Size.ExtraSmall;

interface Props {
  size?: BadgeSize;
  icon?: React.ReactNode;
  label?: string | React.ReactNode;
  color: Color;
  withTransparentIcon?: boolean;
  boldLabel?: boolean;
  tooltip?: string | undefined;
  labelSize?: BadgeSize;
  heightAuto?: boolean;
  monochrome?: boolean;
}

const Badge: React.FC<Props> = ({
  icon,
  label,
  size = Size.Medium,
  color,
  withTransparentIcon,
  boldLabel,
  tooltip,
  labelSize = Size.Medium,
  heightAuto,
  monochrome
}) => {
  if (typeof icon === 'string' || typeof icon === 'number') {
    // eslint-disable-next-line no-param-reassign
    icon = <div>{icon}</div>;
  }

  const BadgeContent = () => (
    <div
      style={heightAuto ? { height: '100%', width: '100%' } : undefined}
      className={`badge badge--${size} badge--${color} ${monochrome ? `badge--${color}-monochrome` : ''}  ${
        withTransparentIcon ? 'badge--icon-transparent' : ''
      } ${boldLabel ? 'badge--bold-label' : ''}
      `}
    >
      {icon && <div className={`badge__icon ${heightAuto ? 'h-100' : ''}`}>{icon}</div>}
      {label && (
        <div className={`badge__label ${!heightAuto ? 'badge__label--small' : ''} ${labelSize ? `badge__label--${labelSize}` : ''}`}>
          <span className={`${!heightAuto ? 'badge__label-text' : ''}`}>{label}</span>
        </div>
      )}
    </div>
  );

  const BadgeItem = () => {
    if (tooltip || label) {
      return (
        <Tooltip text={tooltip ?? label} placement="top">
          {BadgeContent()}
        </Tooltip>
      );
    }
    return <>{BadgeContent()}</>;
  };

  return <div>{BadgeItem()}</div>;
};

export default Badge;
